import React from 'react';
import { reduxForm, Field } from 'redux-form';

import { makeStyles } from '@material-ui/core/styles';

import { graff } from '../../graff';
import { validatePassword } from '../../utils';
import ReduxFormTextField from './../../components/reduxFormMUIWrapper/ReduxFormTextField';

const useStyles = makeStyles({
	field: {
		marginBottom: 16
	},
	label: {
		display: 'block',
		marginBottom: 6,
		fontSize: 13,
		fontWeight: 600,
		color: graff.color.muted
	},
	// Kept for Enter to submit, out of sight.
	submit: {
		position: 'absolute',
		width: 1,
		height: 1,
		padding: 0,
		margin: -1,
		overflow: 'hidden',
		clip: 'rect(0 0 0 0)',
		border: 0
	}
});

const validate = values => {
	const errors = {};
	if (!values.username) {
		errors.username = 'Required';
	}
	validatePassword(values.password, errors);
	return errors;
};

const LoginForm = (props) => {
	const { handleSubmit } = props;
	const classes = useStyles();
	return (
		<form onSubmit={handleSubmit}>
			<div className={classes.field}>
				<span className={classes.label}>Email ou pseudo</span>
				<Field
					name='username' component={ReduxFormTextField}
					label="Email ou pseudo"
					variant='outlined'
					fullWidth
				/>
			</div>
			<div className={classes.field}>
				<span className={classes.label}>Mot de passe</span>
				<Field
					name='password' component={ReduxFormTextField}
					label="Mot de passe"
					type='password'
					variant='outlined'
					fullWidth
				/>
			</div>
			<input id='login' type="submit" tabIndex={-1} className={classes.submit}/>
		</form>
	)
};

export default reduxForm({
	form: 'login',
	validate
})(LoginForm);
